const uySeguroDeSaludBpsOptions = [
  {
    value: "SS15, 4%",
    description: "SS15, 4%",
  },
  {
    value: "Sin hijos ni cónyuge, 5%",
    description: "Sin hijos ni cónyuge, 5%",
  },
  {
    value: "SS1, 6%",
    description: "SS1, 6%",
  },
  {
    value: "SS17, 6%",
    description: "SS17, 6%",
  },
  {
    value: "SS16, 8%",
    description: "SS16, 8%",
  },
];

const uyPreviousEmploymentStatusOptions = [
  {
    value: "employed",
    description: "Employed",
  },
  {
    value: "unemployed",
    description: "Unemployed",
  },
  {
    value: "first_time_searching",
    description: "First time searching",
  },
];

const uyEducationLevelOptions = [
  {
    value: "no_education",
    description: "No education",
  },
  {
    value: "primary",
    description: "Primary",
  },
  {
    value: "secondary",
    description: "Secondary",
  },
  {
    value: "technical_school_utu",
    description: "Technical school (UTU)",
  },
  {
    value: "university",
    description: "University",
  },
  {
    value: "non_university_tertiary",
    description: "Non-university tertiary",
  },
];

export {
  uySeguroDeSaludBpsOptions,
  uyPreviousEmploymentStatusOptions,
  uyEducationLevelOptions,
};
